import { render, staticRenderFns } from "./rationalDietResponse.vue?vue&type=template&id=10c6c59a&scoped=true&"
import script from "./rationalDietResponse.vue?vue&type=script&lang=js&"
export * from "./rationalDietResponse.vue?vue&type=script&lang=js&"
import style0 from "./rationalDietResponse.vue?vue&type=style&index=0&id=10c6c59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6c59a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c6c59a')) {
      api.createRecord('10c6c59a', component.options)
    } else {
      api.reload('10c6c59a', component.options)
    }
    module.hot.accept("./rationalDietResponse.vue?vue&type=template&id=10c6c59a&scoped=true&", function () {
      api.rerender('10c6c59a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/components/rationalDietResponse.vue"
export default component.exports